import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CookieNames } from '../../constant';
/**
* Importing shared services
*/
import { LoginService } from './login.service';
import { CookieManagerService } from '../../../shared/services/cookie-manager.service';
import { BasicRoutes } from '../../constant';

@Injectable()
export class LoginGuardService implements CanActivate{

  constructor(private loginService: LoginService, private cookieManagerService: CookieManagerService, private router: Router) { }

  canActivate(): boolean {
    return this.checkLogin();
  }

  checkLogin(): boolean {
    if (this.cookieManagerService.getCookie(CookieNames.loginKey, false)) {
      return true;
    }
    this.router.navigate([BasicRoutes.login]);
    return false;
  }

  isPaperStarts():boolean{
    return false;
  }

  checkSubscriptionValidity( localStorageValue, actualValue){
    if(localStorageValue === actualValue){
      return true;
    }
    else{
      return false;
    }
  }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/login/services/login-guard.service.ts